import { render, staticRenderFns } from "./BulkSetVipModal.vue?vue&type=template&id=2f1f4ee0"
import script from "./BulkSetVipModal.vue?vue&type=script&lang=js"
export * from "./BulkSetVipModal.vue?vue&type=script&lang=js"
import style0 from "./BulkSetVipModal.vue?vue&type=style&index=0&id=2f1f4ee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports